/** Renders Day / Week / Month grid for PlanPage. */
import CalendarView from '@/features/planning/components/time-grid/CalendarView';
import WeekView from '@/features/planning/components/horizon/WeekView';
import MonthView from '@/features/planning/components/horizon/MonthView';

export function PlanPageView({
  activeView,
  weekDays,
  filteredTasks,
  welcomePlanTour,
}) {
  if (activeView === 1) {
    return <WeekView weekDays={weekDays} tasks={filteredTasks || []} />;
  }
  if (activeView === 2) return <MonthView tasks={filteredTasks || []} />;
  return (
    <CalendarView
      onboardingHighlightTimeSlot={welcomePlanTour.highlightTimeSlot}
      onboardingResizeHighlightTaskId={welcomePlanTour.durationHighlightTaskId}
    />
  );
}
